import  { BOOKED_TIME } from  './ActionTypes';
import api from '../api'
// import { MESSAGE } from "../helpers/constants"
import { toast } from 'react-toastify';

export function getBookedTime(id) {
    return function (dispatch) {
        api.get('bookings').then(async (response) => {
            if (response.status === "success") {
                
                await dispatch({
                    type: BOOKED_TIME,
                    data: response.payload
                });
            }
        });
    }
}

export function postBookingTime(router, data) {
    return function (dispatch) {        
        api.post('bookings', data).then(async (response) => {
            if (response.status === "success") {              
                api.get('bookings').then(async (response) => {
                    if (response.status === "success") {
                        await dispatch({
                            type: BOOKED_TIME,
                            data: response.payload
                        });
                    }
                });
                toast.success(response.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                router.setState({
                    classModelOpen: false,
                    bookingSessionModelOpen:false,
                    library_id: null,
                    taken_by: null,
                    start_time:null,
                    end_time: null,
                    day_of_week: '',
                    date: null,
                    description: '',               
                    library_id_error: false,
                    bookable_id_error: false,
                    start_time_error: false,
                    end_time_error: false,
                    day_of_week_error: false,
                    date_error: false, 
                    booked_time: [],
                    booking_slot_time: [],
                    inavlid_end_time_error: false             
                  })
               } else {              
                toast.error(response.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        });
    }
}

export function teamBookingUpdate(id,status,ref){
	return function(dispatch){
		let data = {};
		data.status = status
		api.put("bookings/"+id, data).then(async (response) => {
			if (response.status === "success") {
            if(ref !== undefined){
                let updatedData = ref.state.selectedData;
                updatedData.status = status
                ref.setState({
                    selectedData: updatedData
                });
            }
             dispatch(getBookedTime())
			}
		})
	}
}